<div class="gov-modal is-active is-visible" role="dialog">
    <div class= "gov-modal__content">
        <div class="gov-modal__header">
            <h2 id="modal-title">{{ 'sdg.grid.confirmation' | localize }}</h2>
        </div>
        <div class="gov-modal__content-inner">
            <p id="modal-description">{{ message }}</p>
            <div class="confirm__buttons">
                <button 
                    class="btn btn-primary gov-button--primary me-5"
                    (click)="onClose(true)"
                >{{ 'sdg.obecne.boolean.1' | localize }}</button>
                <button 
                    class="btn btn-secondary gov-button--primary-outlined"
                    (click)="onClose(false)"
                >{{ 'sdg.obecne.boolean.0' | localize }}</button>
            </div>
        </div>
        <button
            class="gov-button gov-button--secondary gov-modal__close" aria-labelledby="modal-close"
            (click)="onClose(false)"
        >
            <span id="modal-close" class="u-sr-only gov-button__label">{{ 'sdg.obecne.zavrit' | localize }}</span>
        </button>
    </div>
    <div class="gov-modal__backdrop" (click)="onClose(false)"></div>
</div>

